module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-back001.4c01c6e4.jpg";